export default __webpack_public_path__ + "static/media/upperStage.afb1355b.jpg";